import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {SecureApi} from '../../core/secure.api';

@Injectable()
export class LandingPageService {
    constructor(
        public secureApi: SecureApi,
        public http : HttpClient
    ) {

    }

    getCountry()  {
        return this.http.get('https://api.country.is');
    }

}
